import React from "react";
import ShowChartIcon from "@material-ui/icons/ShowChart";
import ThumbDownAltIcon from "@material-ui/icons/ThumbDownAlt";
import BlockIcon from "@material-ui/icons/Block";
import CardTravelIcon from "@material-ui/icons/CardTravel";
import ReceiptIcon from "@material-ui/icons/Receipt";
import CallMadeIcon from '@material-ui/icons/CallMade';

export const showCartIcon = (
  <ShowChartIcon
    fontSize="large"
    style={{ backgroundColor: "#7199FF" }}
    color="secondary"
  ></ShowChartIcon>
);

export const thumbDownAltIcon = (
  <ThumbDownAltIcon
    fontSize="large"
    style={{ backgroundColor: "#3246D3" }}
    color="secondary"
  ></ThumbDownAltIcon>
);

export const cardTravelIcon = (
  <CardTravelIcon
    fontSize="large"
    style={{ backgroundColor: "#15E99D" }}
    color="secondary"
  ></CardTravelIcon>
);

export const flagOutlinedIcon = (
  <BlockIcon
    fontSize="large"
    style={{ backgroundColor: "#ff6666" }}
    color="secondary"
  ></BlockIcon>
);

export const receiptIcon = (
  <ReceiptIcon
    fontSize="large"
    style={{ backgroundColor: "#ff6666" }}
    color="secondary"
  ></ReceiptIcon>
);

export const callMadeIcon = (
  <CallMadeIcon
    fontSize="large"
    style={{ backgroundColor: "#43b443" }}
    color="secondary"
  ></CallMadeIcon>
);

